














import { Vue, Component, Prop } from 'vue-property-decorator';
import BaseH4 from '../base-headings/_base-h4.vue';
import { BaseParagraph, EParagraphSize } from '../base-paragraph';

@Component({
  name: 'BaseListItem',
  data: () => ({
    EParagraphSize,
  }),
  components: {
    BaseH4,
    BaseParagraph,
  },
})
export default class BaseListItem extends Vue {
  @Prop() title: string;
  @Prop() description: string;

  get hasLeftSlot(): boolean {
    return !!this.$slots['left'];
  }
}
